/**
 * Route path helpers keyed by page + language.
 * French is the default; French pages use French URLs.
 */

export const PATHS = {
  home: { fr: "/fr", en: "/en" },
  privacy: {
    fr: "/fr/politique-de-confidentialite",
    en: "/en/privacy-policy",
  },
  cookies: {
    fr: "/fr/politique-des-cookies",
    en: "/en/cookie-policy",
  },
  terms: {
    fr: "/fr/conditions-generales",
    en: "/en/terms-and-conditions",
  },
};

export const THANK_YOU_PATH = "/thank_you";

export function pathFor(pageKey, lang) {
  const entry = PATHS[pageKey];
  if (!entry) return "/";
  return entry[lang] || entry.fr;
}

/**
 * Given the current pathname, return the equivalent path in the target language.
 * Falls back to the target language home if no mapping is found.
 */
export function switchLangPath(pathname, targetLang) {
  for (const key of Object.keys(PATHS)) {
    const entry = PATHS[key];
    if (entry.fr === pathname || entry.en === pathname) {
      return entry[targetLang];
    }
  }
  return PATHS.home[targetLang];
}
